import React, { useEffect, useState } from 'react';
import { TutorialsClientCardsContainer } from './TutorialsClientCardsContainer';
import { Card } from './components/Card';
import './index.css';
import Fetch from '../../../util/core/Fetch';
import config from '../../../../application/config/config';
import { getUserSession } from '../../../util/core/Session';

export function TutorialsClientCards() {
    const [cards, setCards] = useState([]);
    const session = getUserSession();
    const pathBackEnd = 'core/tutorial/';
    const paths = {
      endpoint: config.endpoints.backend + pathBackEnd + 'getByCoreApplicationInstanceIdAndCoreUserId',
      endpointGeneralAdmOrAdmin: config.endpoints.backend + pathBackEnd + 'getByCoreApplicationInstanceId',
    };

    async function getTutorials() {
        const isGeneralAdmOrPlatAdm = session.user.application_instance_id === '1b0996dc-8ad5-4f6f-8393-539fffc02b9f' || session.user.application_instance_id === '013aee58-14f6-4f74-ada7-e95e8eadfcf9';
        if (isGeneralAdmOrPlatAdm) {
            const response = await Fetch.post(paths.endpointGeneralAdmOrAdmin, { 
                core_application_instance_id: session.user.application_instance_id,
                core_user_id: session.user.id
            });
            
            const filteredItens = response.tutorial_itens;

            setCards(filteredItens);
        } else {
            const response = await Fetch.post(paths.endpoint, { 
                core_application_instance_id: session.user.application_instance_id, 
                core_application_id: session.user.application_id,
                core_user_id: session.user.id
            });
            
            const filteredItens = response.tutorial_itens.filter((tutorial) => {
                return tutorial.published === "1";
            });

            setCards(filteredItens);
        }
    }

    useEffect(() => {
        getTutorials();
    },[]);

    return (
        <TutorialsClientCardsContainer labelTitle="Tutoriais">
            <div className='cards-tutorial-container'>
                {cards?.map((card) => (
                    <React.Fragment key={card._id}>
                        <Card 
                            id={card._id}
                            icon={card.icon}
                            title={card.title} 
                            description={card.description}
                            viewed_videos={card.viewed_videos}
                        />
                    </React.Fragment>
                ))}
            </div>
        </TutorialsClientCardsContainer>
    )
};